module.exports = __webpack_public_path__ + "img/no-books.86065b79.png";